import { Component, Input } from '@angular/core';

@Component({
    selector: 'data-card',
    styleUrls: ['./data-card.component.scss'],
    template: `
        <div class="data-card-container" [class.light-border]="lightBorder">
            <div class="data-card">
                <ng-content></ng-content>
            </div>
            <div class="data-card-sub-section" *ngIf="showSubSection">
                <ng-content select="[data-card-sub-section]"></ng-content>
            </div>
        </div>
    `
})
export class DataCardComponent {
    @Input() public lightBorder = false;
    @Input() public showSubSection = false;
}
